import { WorldpayCustomisation } from '../../models/worldpay/worldpay-customisation.interface';
import { mockWorldpayCustomisationButtons } from './worldpay-customisation-buttons.mock';
import { mockWorldpayCustomisationInputs } from './worldpay-customisation-inputs.mock';
import { mockWorldpayCustomisationPage } from './worldpay-customisation-page.mock';

export const mockWorldpayCustomisation: WorldpayCustomisation = {
  backgroundColor: '#00000',
  buttons: mockWorldpayCustomisationButtons,
  color: '#00000',
  fonts: {
    family: [],
  },
  inputs: mockWorldpayCustomisationInputs,
  page: mockWorldpayCustomisationPage,
};
